import React from "react";
import Skeleton from "@mui/material/Skeleton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";

const SkeletonMainPage = () => {
    return (
        <List>
            {Array.from(Array(4)).map((_, index) => (
                <ListItem key={index} divider>
                    <ListItemAvatar>
                        <Skeleton
                            animation="wave"
                            variant="circular"
                            width={30}
                            height={30}
                        />
                    </ListItemAvatar>
                    <ListItemText
                        primary={
                            <Skeleton
                                animation="wave"
                                variant="rectangular"
                                width="40%"
                                height={15}
                            />
                        }
                        secondary={
                            <Skeleton
                                animation="wave"
                                height={10}
                                width="35%"
                                style={{ marginTop: 6 }}
                            />
                        }
                    />
                    <Skeleton
                        animation="wave"
                        height={26}
                        width="13%"
                        variant="rounded"
                        sx={{borderRadius: 5}}
                    />
                </ListItem>
            ))}
        </List>
    );
};

export default SkeletonMainPage;
